import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Layout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const links = [
    { to: "/", label: "Engagements", testid: "nav-engagements" },
    { to: "/workload", label: "Workload", testid: "nav-workload" },
    { to: "/timesheet", label: "Timesheet", testid: "nav-timesheet" },
    ...(user?.role === "admin" || user?.role === "supervisor"
      ? [{ to: "/staff", label: "Staff", testid: "nav-staff" }]
      : []),
  ];

  const signOut = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA]">
      <header className="border-b border-border bg-white">
        <div className="flex flex-wrap items-center gap-6 px-6 py-4 lg:px-10">
          <div className="flex items-baseline gap-3">
            <h1 className="font-display text-2xl font-extrabold">RNA &amp; CO</h1>
            <span className="hidden text-xs uppercase tracking-[0.2em] text-zinc-500 sm:inline">
              Engagement Status 2026
            </span>
          </div>
          <nav className="flex items-center gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end
                data-testid={l.testid}
                className={({ isActive }) =>
                  `px-3 py-1.5 text-sm font-medium rounded-sm transition-colors ${
                    isActive
                      ? "bg-zinc-900 text-white"
                      : "text-zinc-600 hover:bg-zinc-100 hover:text-zinc-900"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
          </nav>
          <div className="ml-auto flex items-center gap-4">
            <div className="text-right leading-tight">
              <div data-testid="current-user-name" className="text-sm font-semibold">
                {user?.name}
              </div>
              <div className="text-[10px] uppercase tracking-widest text-zinc-500">{user?.role}</div>
            </div>
            <button
              data-testid="logout-btn"
              onClick={signOut}
              className="flex items-center gap-2 border border-border px-3 py-1.5 text-sm transition-colors hover:bg-zinc-900 hover:text-white"
            >
              <LogOut className="h-4 w-4" /> Sign out
            </button>
          </div>
        </div>
      </header>
      <main className="px-6 py-8 lg:px-10">
        <Outlet />
      </main>
    </div>
  );
}
